export default "#version 300 es\n\nlayout(location = 0) in vec4 a_pos;\n\nvoid main() {\n    gl_Position = a_pos;\n}\n"